import actions from 'src/modules/asset/list/assetListActions';

const INITIAL_PAGE_SIZE = 12;

const initialData = {
  rows: [],
  count: 0,
  loading: false,
  filter: {},
  rawFilter: {},
  pagination: {
    current: 1,
    pageSize: INITIAL_PAGE_SIZE,
  },
  sorter: {},
  selectedKeys: [],
  templates: [],
  templatesLoading: false,
};

export default (state = initialData, { type, payload }: { type: any; payload?: any }) => {
  if (type === actions.RESETED) {
    return {
      ...initialData,
      templates: state.templates,
      templatesLoading: state.templatesLoading,
      pagination: {
        current: 1,
        pageSize: state.pagination.pageSize,
      },
    };
  }

  if (type === actions.SELECTEDS_CHANGED) {
    return {
      ...state,
      selectedKeys: payload || [],
    };
  }

  if (type === actions.PAGINATION_CHANGED) {
    return {
      ...state,
      pagination: payload || {
        current: 1,
        pageSize: INITIAL_PAGE_SIZE,
      },
    };
  }

  if (type === actions.SORTER_CHANGED) {
    return {
      ...state,
      sorter: payload || {},
    };
  }

  if (type === actions.FETCH_STARTED) {
    return {
      ...state,
      loading: true,
      selectedKeys: [],
      filter: payload ? payload.filter : {},
      rawFilter: payload ? payload.rawFilter : {},
      pagination:
        payload && payload.keepPagination
          ? state.pagination
          : {
              current: 1,
              pageSize: state.pagination.pageSize,
            },
    };
  }

  if (type === actions.FETCH_SUCCESS) {
    return {
      ...state,
      loading: false,
      rows: payload.rows,
      count: payload.count,
    };
  }

  if (type === actions.FETCH_ERROR) {
    return {
      ...state,
      loading: false,
      rows: [],
      count: 0,
    };
  }

  if (type === actions.EXPORT_STARTED) {
    return {
      ...state,
      exportLoading: true,
    };
  }

  if (type === actions.EXPORT_SUCCESS) {
    return {
      ...state,
      exportLoading: false,
    };
  }

  if (type === actions.EXPORT_ERROR) {
    return {
      ...state,
      exportLoading: false,
    };
  }

  if (type === actions.TEMPLATES_FETCH_STARTED) {
    return {
      ...state,
      templatesLoading: true,
    };
  }

  if (type === actions.TEMPLATES_FETCH_SUCCESS) {
    return {
      ...state,
      templatesLoading: false,
      templates: payload || [],
    };
  }

  if (type === actions.TEMPLATES_FETCH_ERROR) {
    return {
      ...state,
      templatesLoading: false,
      templates: [],
    };
  }

  return state;
};
